/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, {
  useState, useEffect, useMemo, useRef,
} from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import styled from '@emotion/styled';
import ResizeObserver from 'react-resize-observer';
import { VariableSizeList as List } from 'react-window';
import { Field } from 'formik';
import IcomoonReact from 'icomoon-react';
import { useTheme } from 'emotion-theming';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';
import Input from '../../../../shared/_TBComponents/Input/index';
import VideoAndUrlInput from './VideoAndUrlInputs';
import SelectBox from '../../../../shared/_TBComponents/SelectBox/index';
import {
  setActiveSecondLayerModal, fetchDocument, addAsset,
} from '../../ducks/calendarActions';
import { showErrorToast } from '../../../../shared/utils/toastManager';

const DescriptionContainer = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const LiftInputsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const AdditionalOptionsHeaderRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const AdditionalOptionsTextAndArrowIconContainer = styled('div')`
 display: flex;
 align-items: center;
 cursor: pointer;
 gap: 8px;
 transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const Seperator = styled('div')`
  display: flex;
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.colors.borderLight};
`;

const LiftInputsRow = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.containerWidth < 528 ? 'column' : 'row')};
  gap: 32px;
`;

const LiftInputsSubContainer = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;

const LinkContainer = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.containerWidth < 840 ? 'column' : 'row')};
  gap: 16px;
`;

const InputTypeAndPRTrackingContainer = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.containerWidth < 840 ? 'column' : 'row')};
  gap: 16px;
`;

const OuterLinkContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

const StyledTextArea = styled('textarea')`
  width: 100%;
  height: 100%;
  min-height: 82px !important;
  padding: 10px;
  font-size: 16px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 4px;
  font-family: 'Nunito Sans';
  color: ${({ theme }) => theme.colors.text};
  background: ${({ theme }) => theme.colors.surfaceInput};
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.hover};
    box-shadow: none;
  }
  ::placeholder {
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  :disabled {
    background: ${({ theme }) => theme.colors.surface};
    border-color: ${({ theme }) => theme.colors.borderLight};
    color: ${({ theme }) => theme.colors.textTertiary};
  }
`;

const AddAssetButtonContainer = styled('div')`
  display: flex;
  gap: 4px;
  cursor: pointer;
  align-items: center;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const AssetButtonContainer = styled('div')`
  position: relative;
  display: flex;
  gap: 4px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 8px;
  padding-right: 8px;
  cursor: pointer;
  align-items: center;
  border-radius: 4px;
  width: fit-content;
`;

const ClearAssetIconContainer = styled('div')`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: ${({ theme }) => theme.colors.borderMedium};
  padding: 4px;
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const NameAndInputContainer = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  .checkbox-input {
    appearance: none; /* Remove default checkbox styling */
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    border: 2px solid ${({ theme }) => theme.colors.borderMedium};
    border-radius: 4px;
    outline: none;
    cursor: ${(props) => (props.cursorNotAllowed ? 'not-allowed' : (props.disabled ? 'default' : 'pointer'))};
    position: relative;
    transition: ${TransitionGlobal};
    :hover {
      opacity: 0.7;
    }
  }
  
  .checkbox-input:checked {
    border: ${(props) => (props.disabled ? `2px solid ${props.theme.colors.borderMedium}` : `2px solid ${props.theme.colors.hover}`)};
   }

  .checkbox-input:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: ${(props) => (props.disabled ? `solid ${props.theme.colors.borderMedium}` : `solid ${props.theme.colors.hover}`)};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: block;
  }
`;

const CheckBoxRow = styled('div')`
 display: flex;
 flex-wrap: wrap;
 gap: 16px;
`;

const LabelAndCheckBoxContainerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const AdditionalOptionsWrapper = styled('div')`
  display: flex;
  gap: 16px;
  margin-top: -9px;
  transition: ${TransitionGlobal};
  overflow: hidden;
  max-height: ${(props) => (!props.showAdditionalOptions ? '0px' : '500px')};
`;

const AddAssetsColumn = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

const ExerciseManagementWarning = styled('div')`
  display: flex;
  gap: 12px;
  background: ${({ theme }) => theme.colors.warningSurface};
  border: 1px solid ${({ theme }) => theme.colors.warningBorder};
  border-radius: 8px;
  align-items: center;
  padding: 8px 16px;
  margin-bottom: 11px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.warningText};
  p {
    font-size: 9pt;
  }
`;

const WarningAndInputContainer = styled('div')`
display: flex;
flex-direction: column;
`;

const IconContainer = styled('div')`
display: flex;
min-width: 16px;
`;

const SAQCFormInputs = ({
  errors,
  touched,
  handleChange,
  mediaType,
  videoUrlValue,
  mediaUrlValue,
  trackingValue,
  linkToValue,
  linkPercentageValue,
  setFieldValue,
  handleBlur,
  setFieldTouched,
  setFieldError,
  urlButtonValue,
  containerWidth,
  completionOnlyValue,
  coachCompletionValue,
  setTouched,
  linkPercentageValidationSchema,
  inputTypeValue,
  unitValue,
  prSortOrderValue,
  reusableItemValue,
  hasExerciseManagementAccess,
}) => {
  const dispatch = useDispatch();
  const allExercises = useSelector((state) => state.calendar.data.allExercises);
  const assetToAdd = useSelector((state) => state.calendar.data.addAsset);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const accountCode = currentUser?.accountCode;
  const modalData = useSelector((state) => state.calendar.data.modalData);
  const [includeCheckmarkForNoneOption, setIncludeCheckmarkForNoneOption] = useState(true);
  const [showAdditionalOptions, setShowAdditionalOptions] = useState(true);
  const [addAssetsColumnContainerWidth, setAddAssetsColumnContainerWidth] = useState(0);
  const [localInputType, setLocalInputType] = useState(inputTypeValue);
  const { colors } = useTheme();

  useEffect(() => {
    if (assetToAdd) {
      setFieldValue('documentId', assetToAdd?.id);
    }
  }, [assetToAdd]);

  const validateLinkPercentageAndSetFieldErrorOnChange = async (value) => {
    try {
      await linkPercentageValidationSchema.validate(value);
    } catch (err) {
      setFieldError('name', err.message);
    }
  };

  const linkToOptions = [
    {
      name: 'None',
      id: 'none',
      includeCheckmark: includeCheckmarkForNoneOption,
      checkmarkColor: colors.textTertiary,
    },
    ...allExercises
      .filter((exercise) => exercise.type === 'R' && exercise.inputType === localInputType) /** Filter the exercises */
      .map((exercise) => ({
        name: exercise.name,
        id: exercise.id,
        includeCheckmark: linkToValue === exercise?.id,
        checkmarkColor: colors.textTertiary,
      })),
  ];

  const memoizedLinkToOptions = useMemo(() => linkToOptions, [allExercises, includeCheckmarkForNoneOption, linkToValue, localInputType, modalData]);

  const PRTrackingOptions = [
    {
      name: 'Disabled',
      id: 0,
      includeCheckmark: prSortOrderValue === 0,
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Higher Value is Better',
      id: 1,
      includeCheckmark: prSortOrderValue === 1,
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Lower Value is Better',
      id: 2,
      includeCheckmark: prSortOrderValue === 2,
      checkmarkColor: colors.textTertiary,
    },
  ];

  const inputTypeOptions = [
    {
      options: [
        {
          name: 'None(Completion Only)', /** inputType = 'C' */
          id: 'None(Completion Only)',
          includeCheckmark: unitValue === 'None(Completion Only)',
          checkmarkColor: colors.textTertiary,
          inputType: 'C',
        },
      ],
    },
    {
      label: 'Time', /** inputType = 'T' */
      options: [
        {
          name: 'Minutes & Seconds',
          id: 'MS',
          includeCheckmark: unitValue === 'MS',
          checkmarkColor: colors.textTertiary,
          isGrouped: true,
          inputType: 'T',
        },

        {
          name: 'Seconds',
          id: 'S',
          includeCheckmark: unitValue === 'S',
          checkmarkColor: colors.textTertiary,
          isGrouped: true,
          inputType: 'T',
        },
      ],
    },
    {
      label: 'Distance', /** inputType = 'D' */
      options: [
        {
          name: 'Centimeters',
          id: 'CM',
          includeCheckmark: unitValue === 'CM',
          checkmarkColor: colors.textTertiary,
          isGrouped: true,
          inputType: 'D',
        },
        {
          name: 'Feet & Inches',
          id: 'F',
          includeCheckmark: unitValue === 'F',
          checkmarkColor: colors.textTertiary,
          isGrouped: true,
          inputType: 'D',
        },
        {
          name: 'Inches',
          id: 'I',
          includeCheckmark: unitValue === 'I',
          checkmarkColor: colors.textTertiary,
          isGrouped: true,
          inputType: 'D',
        },
        {
          name: 'Kilometers',
          id: 'K',
          includeCheckmark: unitValue === 'K',
          checkmarkColor: colors.textTertiary,
          isGrouped: true,
          inputType: 'D',
        },
        {
          name: 'Meters',
          id: 'M',
          includeCheckmark: unitValue === 'M',
          checkmarkColor: colors.textTertiary,
          isGrouped: true,
          inputType: 'D',
        },
        {
          name: 'Miles',
          id: 'L',
          includeCheckmark: unitValue === 'L',
          checkmarkColor: colors.textTertiary,
          isGrouped: true,
          inputType: 'D',
        },
        {
          name: 'Yards',
          id: 'Y',
          includeCheckmark: unitValue === 'Y',
          checkmarkColor: colors.textTertiary,
          isGrouped: true,
          inputType: 'D',
        },
      ],
    },
    {
      label: 'Other', /** inputType = 'O' */
      options: [
        {
          name: 'Calories',
          id: 'CL',
          includeCheckmark: unitValue === 'CL',
          checkmarkColor: colors.textTertiary,
          isGrouped: true,
          inputType: 'O',
        },

        {
          name: 'Kilometer/Hours (KPH)',
          id: 'KH',
          includeCheckmark: unitValue === 'KH',
          checkmarkColor: colors.textTertiary,
          isGrouped: true,
          inputType: 'O',
        },
        {
          name: 'Miles/Hour (MPH)',
          id: 'MH',
          includeCheckmark: unitValue === 'MH',
          checkmarkColor: colors.textTertiary,
          isGrouped: true,
          inputType: 'O',
        },

        {
          name: 'Watts',
          id: 'W',
          includeCheckmark: unitValue === 'W',
          checkmarkColor: colors.textTertiary,
          isGrouped: true,
          inputType: 'O',
        },
      ],
    },
  ];

  const AthleteInputCheckBoxDataArray = [
    {
      name: 'cardioComp',
      label: 'Completion Only',
      checked: inputTypeValue === 'C' ? true : completionOnlyValue,
    }, {
      name: 'cardioCoach',
      label: 'Coach Completion',
      checked: coachCompletionValue,
    },
  ];

  const customSelectStylesLinkTo = {
    control: (provided, state) => ({
      ...provided,
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: 400,
      background: colors.surfaceInput,
      borderColor: state.isFocused ? colors.hover : colors.borderLight,
      boxShadow: state.isFocused ? 'none' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? colors.hover : colors.borderLight,
      },
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '8px 12px',
      backgroundColor: state.isSelected ? colors.surfaceSecondary : colors.surfaceElevated,
      color: state.isSelected || ((linkToValue === 'none' || linkToValue === null) && state.data.id === 'none') || (trackingValue === 0 && state.data.id === 0) ? colors.textTertiary : colors.text,
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: state.data.__isNew__ ? 700 : 400,
      '&:hover': {
        backgroundColor: colors.surfaceSecondary,
      },
      paddingLeft: state.data.isGrouped && '12px',
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: colors.surfaceSecondary,
      border: `1px solid ${colors.borderLight}`,
      borderRadius: '4px',
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: colors.text,
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: colors.textSecondary,
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: colors.surfaceElevated,
      color: colors.text,
      border: '0px',
      minWidth: '250px',
      padding: '4px 0',
      marginTop: '0px',
      marginBottom: '0px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '500px',
    }),
    group: (provided) => ({
      ...provided,
      padding: '0px',
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontSize: '16px',
      fontWeight: 700,
      color: colors.textSecondary,
      paddingLeft: '0px',
      paddingRight: '0px',
      marginBottom: '8px',
      fontFamily: 'Nunito Sans',
      textTransform: 'none',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: colors.textSecondary,
    }),
    input: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? 'inherit' : provided.color, /** Use 'inherit' to maintain original color */
    }),
  };

  const MenuList = (props) => {
    const { children, maxHeight } = props;
    const listRef = useRef({});
    const rowHeights = useRef({});
    /** Calculate height based on the children length or a default */
    const childrenLengthBy40 = children?.length ? children.length * 40 : 40;
    const height = Math.min(childrenLengthBy40, maxHeight);
    const getRowHeight = (index) => rowHeights.current[index] + 8 || 40;

    return (
      <div style={{ height }}>
        {!children.length ? (
          <List
            ref={listRef}
            height={40}
            itemCount={1}
            itemSize={() => 40}
          >
            {({ style }) => (
              <div style={{
                ...style, display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
              >
                <Text fontSize='16px' color='hsl(0, 0%, 60%)'>No options</Text>
              </div>
            )}
          </List>

        ) : (
          <List
            ref={listRef}
            height={height}
            itemCount={children.length}
            itemSize={(index) => getRowHeight(index)}
          >
            {({ index, style }) => {
              const rowRef = useRef({});

              useEffect(() => {
                if (rowRef.current) {
                  const rowHeight = rowRef.current.getBoundingClientRect().height;
                  /** Store this index's height and reset the List after each update */
                  if (rowHeights.current[index] !== rowHeight) {
                    rowHeights.current[index] = rowHeight;
                    listRef.current?.resetAfterIndex(index); /** Reset from this index to recalculate sizes */
                  }
                }
              }, [index]);

              return (
                <div style={style}>
                  <div ref={rowRef}>
                    {children[index]}
                  </div>
                </div>
              );
            }}
          </List>
        )}
      </div>
    );
  };

  const MemoizedMenuList = React.memo(MenuList);

  return (
    <LiftInputsContainer>
      <LiftInputsRow containerWidth={containerWidth}>
        <VideoAndUrlInput
          errors={errors}
          touched={touched}
          mediaType={mediaType}
          videoUrlValue={videoUrlValue}
          mediaUrlValue={mediaUrlValue}
          setFieldValue={setFieldValue}
          urlButtonValue={urlButtonValue}
          containerWidth={containerWidth}
          setFieldTouched={setFieldTouched}
          setFieldError={setFieldError}
          isDisabled={modalData?.disabledEditModal}
        />
        <LiftInputsSubContainer>
          <WarningAndInputContainer>
            {!hasExerciseManagementAccess && !modalData?.disabledEditModal && (
            <ExerciseManagementWarning>
              <IconContainer>
                <IcomoonReact
                  iconSet={iconSet}
                  size={16}
                  icon='warning'
                  color='#F59E0B'
                />
              </IconContainer>
              <Text>You do not have the user permissions required to save to the exercise database.</Text>
            </ExerciseManagementWarning>
            )}
            <NameAndInputContainer disabled={modalData?.disabledEditModal || !hasExerciseManagementAccess}>
              <input
                disabled={modalData?.disabledEditModal || !hasExerciseManagementAccess}
                className='checkbox-input'
                type='checkbox'
                name='reusableItem'
                onChange={() => {
                  setFieldValue('reusableItem', !reusableItemValue);
                  /** if the user goes to uncheck save to database we need to set
                 * prSortOrder value back to 0 if there is one and we need to hide
                 * prSortOrder as an input option
                 */
                  if (reusableItemValue) {
                    setFieldValue('prSortOrder', 0);
                  }
                }}
                checked={reusableItemValue}
              />
              <Text color={(modalData?.disabledEditModal || !hasExerciseManagementAccess) && colors.textTertiary} fontSize='16px' style={{ whiteSpace: 'nowrap ' }}>Save to Database</Text>
            </NameAndInputContainer>
          </WarningAndInputContainer>
          <OuterLinkContainer>
            <InputTypeAndPRTrackingContainer containerWidth={containerWidth}>
              <SelectBox
                isDisabled={modalData?.disabledEditModal}
                options={inputTypeOptions}
                value={inputTypeOptions
                  .flatMap((group) => group.options)
                  .find((option) => option.id === unitValue)}
                onChangeFunction={(option) => {
                  setFieldValue('unit', option.id);
                  setFieldValue('inputType', option.inputType);
                  setLocalInputType(option.inputType);
                  /** clear link to value and PR tracking value */
                  setFieldValue('linkTo', 'none');
                  setIncludeCheckmarkForNoneOption(true);
                  setFieldValue('prSortOrder', 0);
                }}
                onBlur={() => setFieldTouched('unit', true)}
                error={!!touched.unit && !!errors.unit}
                errorMsg={errors.unit}
                title='Input Type'
                titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
                customStyles={customSelectStylesLinkTo}
                isClearable={false}
                styledProps={{ height: '' }}
                width='100%'
                styledPropsInput={{
                  width: '100% !important',
                }}
              />
              {inputTypeValue !== 'C' && !!reusableItemValue && (
              <SelectBox
                isDisabled={modalData?.disabledEditModal}
                options={PRTrackingOptions}
                value={PRTrackingOptions.find((option) => option.id === prSortOrderValue)}
                onChangeFunction={(option) => {
                  setFieldValue('prSortOrder', option.id);
                }}
                onBlur={() => setFieldTouched('prSortOrder', true)}
                error={!!touched.prSortOrder && !!errors.prSortOrder}
                errorMsg={errors.prSortOrder}
                title='PR Tracking'
                titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
                customStyles={customSelectStylesLinkTo}
                isClearable={false}
                styledProps={{ height: '' }}
                styledPropsInput={{
                  width: '100% !important',
                }}
              />
              )}
            </InputTypeAndPRTrackingContainer>
          </OuterLinkContainer>
          {inputTypeValue !== 'C' && (
          <OuterLinkContainer>
            <LinkContainer containerWidth={containerWidth}>
              <SelectBox
                isDisabled={modalData?.disabledEditModal}
                closeOnResize
                options={memoizedLinkToOptions}
                value={
                    memoizedLinkToOptions.find((option) => option.id === linkToValue)?.id === 'none'
                      ? null
                      : memoizedLinkToOptions.find((option) => option.id === linkToValue)
                }
                onChangeFunction={(option) => {
                  setIncludeCheckmarkForNoneOption(option.id === 'none');
                  if (option.id === 'none') {
                    setFieldValue('linkTo', 'none');
                    setFieldValue('linkPercentage', null);
                  } else {
                    setFieldValue('linkTo', parseInt(option.id, 10));
                    setFieldValue('linkPercentage', 100);
                  }
                }}
                onBlur={() => setFieldTouched('linkTo', true)}
                error={!!touched.linkTo && !!errors.linkTo}
                errorMsg={errors.linkTo}
                title='Link to'
                titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
                customStyles={customSelectStylesLinkTo}
                isClearable={false}
                menuListComponent={MemoizedMenuList}
                width='100%'
                styledPropsInput={{
                  width: '100% !important',
                }}
              />
              {linkToValue && linkToValue !== 'none' && (
              <Input
                disabled={modalData?.disabledEditModal}
                error={!!touched.linkPercentage && !!errors.linkPercentage}
                errorMsg={errors.linkPercentage}
                fontSize='16px'
                fontWeight={400}
                height='38px'
                top='38px'
                label='Link Percentage (%PR)'
                name='linkPercentage'
                onChange={(value) => {
                  handleChange(value);
                  setTouched({ linkPercentage: true });
                  validateLinkPercentageAndSetFieldErrorOnChange(value);
                }}
                onBlur={handleBlur}
                right='5px'
                styledPropsLabel={{
                  fontSize: '16px',
                  fontWeight: 700,
                }}
                value={linkPercentageValue}
                width='100% !important'
                styledPropsInput={{
                  width: '100% !important',
                }}
              />
              )}
            </LinkContainer>
          </OuterLinkContainer>
          )}
          <DescriptionContainer>
            <Text
              fontSize='16px'
              fontWeight={700}
              color={modalData?.disabledEditModal && colors.textTertiary}
            >
              Description
            </Text>
            <Field
              name='description'
              className='form-control'
              render={({ field }) => (
                <StyledTextArea disabled={modalData?.disabledEditModal} {...field} />
              )}
            />
            {errors.description && (
            <Text color='#CC0404' fontSize='13px' fontWeight={700} style={{ marginTop: '5px' }}>{errors.description}</Text>
            )}
          </DescriptionContainer>
          <AddAssetsColumn>
            <ResizeObserver
              onResize={(rect) => {
                setAddAssetsColumnContainerWidth(rect?.width);
              }}
            />
            {modalData?.disabledEditModal ? null : (
              <Text fontSize='16px' fontWeight={700}>Attach Document/Link</Text>
            )}
            {assetToAdd ? (
              <AssetButtonContainer onClick={() => {
                const docId = assetToAdd?.id;
                if (assetToAdd.type === 1) {
                  dispatch(fetchDocument(({ accountCode, docId }), {
                    onSuccess: (response) => {
                      window.open(response?.url, '_blank');
                    },
                    onError: () => {
                      showErrorToast('Opps! Something went wrong. Unable to fetch document.');
                    },
                  }));
                }
                if (assetToAdd.type === 2) {
                  window.open(assetToAdd?.url, '_blank');
                }
              }}
              >
                <ClearAssetIconContainer onClick={(e) => {
                  dispatch(addAsset(null));
                  setFieldValue('documentId', null);
                  e.stopPropagation();
                }}
                >
                  <IcomoonReact
                    iconSet={iconSet}
                    size={10}
                    icon='remove'
                    color={colors.textSecondary}
                  />
                </ClearAssetIconContainer>
                <IcomoonReact
                  iconSet={iconSet}
                  size={14}
                  icon={assetToAdd.type === 2 ? 'link' : 'file'}
                  color={colors.textSecondary}
                />
                <Text
                  style={{
                    maxWidth: `${addAssetsColumnContainerWidth - 60}px`,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                  fontSize='16px'
                  color={colors.textSecondary}
                >
                  {assetToAdd?.name}
                </Text>
              </AssetButtonContainer>
            ) : (
              <>
                {!modalData?.disabledEditModal && (
                <AddAssetButtonContainer onClick={() => dispatch(setActiveSecondLayerModal('addAssetModal'))}>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={12}
                    icon='plus'
                    color={colors.hover}
                  />
                  <Text fontSize='16px' color={colors.hover}>Add Asset</Text>
                </AddAssetButtonContainer>
                )}
              </>
            )}
          </AddAssetsColumn>
        </LiftInputsSubContainer>
      </LiftInputsRow>
      <AdditionalOptionsHeaderRow>
        <Seperator />
        <AdditionalOptionsTextAndArrowIconContainer onClick={() => setShowAdditionalOptions(!showAdditionalOptions)}>
          <Text fontSize='18px' color={colors.textSecondary} style={{ minWidth: '210px' }}>Exercise Default Settings</Text>
          <IcomoonReact
            iconSet={iconSet}
            size={8}
            icon={showAdditionalOptions ? 'up-arrow' : 'down-arrow'}
            color={colors.textSecondary}
          />
        </AdditionalOptionsTextAndArrowIconContainer>
        <Seperator />
      </AdditionalOptionsHeaderRow>
      {showAdditionalOptions && (
        <Text fontSize='14px' color={colors.textSecondary} style={{ marginTop: '-8px' }}>Any items checked below will be active when adding this exercise to a workout</Text>
      )}
      <AdditionalOptionsWrapper showAdditionalOptions={showAdditionalOptions}>
        <LabelAndCheckBoxContainerWrapper showAdditionalOptions={showAdditionalOptions}>
          {/* <Text color={modalData?.disabledEditModal && colors.textTertiary} fontWeight={700} fontSize='16px'>Athlete Input</Text> */}
          <CheckBoxRow>
            {AthleteInputCheckBoxDataArray.map((option) => (
              <NameAndInputContainer disabled={modalData?.disabledEditModal} cursorNotAllowed={inputTypeValue === 'C' && option.name === 'cardioComp'}>
                <input
                  className='checkbox-input'
                  type='checkbox'
                  name={option.name}
                  onChange={() => {
                    setFieldValue(`${option.name}`, !option.checked);
                  }}
                  checked={option.checked}
                  disabled={(inputTypeValue === 'C' && option.name === 'cardioComp') || modalData?.disabledEditModal}
                />
                <Text color={modalData?.disabledEditModal && colors.textTertiary} fontSize='16px' style={{ whiteSpace: 'nowrap ' }}>{option.label}</Text>
              </NameAndInputContainer>
            ))}
          </CheckBoxRow>
        </LabelAndCheckBoxContainerWrapper>
      </AdditionalOptionsWrapper>
    </LiftInputsContainer>
  );
};

export default SAQCFormInputs;
